/* eslint-disable import/no-anonymous-default-export */
import React, { useState, useEffect, useRef, useCallback } from "react"
// import OrgChart from "@balkangraph/orgchart.js";
import OrgChart from "../balkan_orgchart/orgchart"
import { makeStyles } from "@mui/styles"
import {
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { ReactComponent as PlusIcon } from "../icons/plus.svg"
import { ReactComponent as MinusIcon } from "../icons/minus.svg"

OrgChart.templates.customTemplate = Object.assign({}, OrgChart.templates.ana)
OrgChart.templates.customTemplate.size = [350, 80]
OrgChart.templates.customTemplate.defs = '<linearGradient id="{randId}" x1="0%" y1="0%" x2="0%" y2="100%"><stop offset="0%" style="stop-color:#fff;stop-opacity:1" />'
  + '<stop offset="100%" style="stop-color:#eee;stop-opacity:1" /></linearGradient>'
  + '<filter id="f3" x="0" y="0" width="200" height="200" > <feOffset result="offOut" in="SourceAlpha" dx="4" dy="4" /> <feColorMatrix result="matrixOut" in="offOut" type="matrix" values=" 0.49 0 0 0 0 0 0.49 0 0 0 0 0 0.49 0 0 0 0 0 0.5 0" /> <feGaussianBlur result="blurOut" in="matrixOut" stdDeviation="6" /> <feBlend in="SourceGraphic" in2="blurOut" mode="normal" /> </filter>'
OrgChart.templates.subLevel.link = '<path stroke-linejoin="round" stroke="#aeaeae" stroke-width="1px" fill="none" d="{rounded}" />'
OrgChart.templates.customTemplate.plus = '<circle cx="15" cy="15" r="10" class="boc-fill" stroke="#aeaeae" stroke-width="1"></circle><path transform="translate(8.8, 13.5)" d="M 0 0 l 6 4 l 6 -4" fill="none" stroke="black" stroke-linecap="round" stroke-width="2" />'
OrgChart.templates.customTemplate.minus = '<circle cx="15" cy="15" r="10" class="boc-fill" stroke="#aeaeae" stroke-width="1"></circle><path transform="translate(4, 11.5)" d="m 5 5 l 6 -4 l 6 4" fill="none" stroke="black" stroke-linecap="round" stroke-width="2" />'
OrgChart.templates.customTemplate.node = '<rect fill="#fff" filter="url(#f3)" x="0" y="0" height="{h}" width="{w}" stroke-width="1" stroke="#aeaeae" rx="7" ry="7"></rect>'
OrgChart.templates.customTemplate.field_0 = '<text data-width="135" style="font-size: 12px;" fill="#AAAAAA" x="80" y="30">{val}</text>'
OrgChart.templates.customTemplate.field_1 = '<text data-width="135" style="font-size: 16px; font-weight: 600;" fill="#404349" x="80" y="47">{val}</text>'
OrgChart.templates.customTemplate.field_2 = '<text data-width="135" style="font-size: 14px;" fill="#404349" x="80" y="63">{val}</text>'
OrgChart.templates.customTemplate.img_0 = '<image preserveAspectRatio="xMidYMid slice" clip-path="url(#{randId})" xlink:href="{val}" x="22" y="20" width="40" height="40"></image>'

var editForm = function () { }

editForm.prototype.init = function (obj) {
  this.chart = obj
}

editForm.prototype.show = function (nodeId) {
  this.hide();
  var node = this.chart.get(nodeId);
  var editHtml = '<table cellpadding="0" cellspacing="5" class="t" style="width: 100%;">'
    + '<tr>'
    + '<td colspan="2" class="t-img" style="border-bottom: 1px solid #E7E8E7;padding-bottom: 15px;">'
    + '<p style="font-weight: 600; font-size: 24px; color: #404349;">Organization Detail</p>'
    + '</td>'
    + '</tr>'
  // detail columns
  editHtml += '<tr>'
  editHtml += '<td class="t-name fw-600">Organization ID</td>'
  editHtml += '<td class="t-name fw-600">Organization Level</td>'
  editHtml += '</tr>'
  editHtml += '<tr>'
  editHtml += '<td class="t-val" style="background: #FAFAFA;">' + (node.code ? node.code : "-") + '</td>'
  editHtml += '<td class="t-val" style="background: #FAFAFA;">' + (node.level ? node.level : "-") + '</td>'
  editHtml += '</tr>'
  editHtml += '<tr>'
  editHtml += '<td class="t-name fw-600">Organization Name (EN)</td>'
  editHtml += '<td class="t-name fw-600">Organization Name (TH)</td>'
  editHtml += '</tr>'
  editHtml += '<tr>'
  editHtml += '<td class="t-val" style="background: #FAFAFA;">' + (node.nameEn ? node.nameEn : "-") + '</td>'
  editHtml += '<td class="t-val" style="background: #FAFAFA;">' + (node.nameTh ? node.nameTh : "-") + '</td>'
  editHtml += '</tr>'
  editHtml += '<tr>'
  editHtml += '<td class="t-name fw-600">Abbreviation (EN)</td>'
  editHtml += '<td class="t-name fw-600">Abbreviation (TH)</td>'
  editHtml += '</tr>'
  editHtml += '<tr>'
  editHtml += '<td class="t-val" style="background: #FAFAFA;">' + (node.acronymEn ? node.acronymEn : "-") + '</td>'
  editHtml += '<td class="t-val" style="background: #FAFAFA;">' + (node.acronymTh ? node.acronymTh : "-") + '</td>'
  editHtml += '</tr>'
  editHtml += '<tr>'
  editHtml += '<td class="t-name fw-600">Date as of</td>'
  editHtml += '</tr>'
  editHtml += '<tr>'
  editHtml += '<td class="t-val" style="background: #FAFAFA;">' + (node.dataAsOf ? node.dataAsOf : "-") + '</td>'
  editHtml += '</tr>'
  editHtml += '</table>'

  var div = document.createElement("div")
  div.id = 'edit-form'
  div.innerHTML = editHtml
  div.style.width = '600px'
  div.style.position = 'absolute'
  div.style.top = '10px'
  div.style.right = '10px'
  div.style.opacity = 1
  div.style.borderRadius = '10px'
  div.style.border = '1px solid #FAFAFA'
  div.style.backgroundColor = '#ffffff'
  div.style.padding = '15px'
  div.style.boxShadow = '7px 8px 18px -10px rgba(0,0,0,0.47)'

  this.chart.element.appendChild(div)
}

editForm.prototype.hide = function (showldUpdateTheNode) {
  var form = this.chart.element.querySelector('#edit-form')
  if (form) {
    form.parentNode.removeChild(form)
  }
}

const useStyles = makeStyles({
  zoomBtn: {
    width: '40px',
    background: '#FFFFFF',
    height: '40px',
    display: "flex",
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #DADADA',
    "&:hover": {
      backgroundColor: "#4f8a80",
    },
  },
})

var chart = null

const OrganizationChart = (props) => {
  const divRef = useRef(null);
  const classes = useStyles();
  const [currentZoomSelected, setCurrentZoomSelected] = useState(100)
  const [isDomChartReady, setIsDomChartReady] = useState(false)

  const findRoot = (data) => {
    let roots = [...data].map(item => {
      if (item.pid === 0) return item.id
    })
    return roots
  }

  const setZoomLevel = (val) => {
    setCurrentZoomSelected(val)
    const scaleInitial = chart.config.scaleInitial
    const currentScale = chart.getScale();
    const resetScale = scaleInitial / currentScale
    if (val === 100) {
      chart.zoom(resetScale / scaleInitial, [50, 50], true)
    } else {
      let valScale = val / 100
      chart.zoom(resetScale * valScale / scaleInitial, [50, 50], true)
    }
  }

  const doZoom = (val) => {
    const scaleInitial = chart.config.scaleInitial
    const currentScale = chart.getScale();
    const resetScale = scaleInitial / currentScale
    const zoomLevel = [25, 50, 75, 100, 150, 200, 300]
    const zoomLevelLength = zoomLevel.length
    let currentZoomLevel = zoomLevel.indexOf(currentZoomSelected)
    let valScale = 0
    if (val === "in") {
      if (currentZoomLevel > -1 && currentZoomLevel < zoomLevelLength - 1) {
        valScale = zoomLevel[currentZoomLevel + 1] / 100
        chart.zoom(resetScale * valScale / scaleInitial, [50, 50], true)
        setCurrentZoomSelected(zoomLevel[currentZoomLevel + 1])
      }
    } else {
      if (currentZoomLevel > 0) {
        valScale = zoomLevel[currentZoomLevel - 1] / 100
        chart.zoom(resetScale * valScale / scaleInitial, [50, 50], true)
        setCurrentZoomSelected(zoomLevel[currentZoomLevel - 1])
      }
    }
  }

  const divRefCallback = useCallback((node) => {
    if (node) {
      divRef.current = node
      setIsDomChartReady(true)
    }
  }, [])

  useEffect(() => {
    if (props.nodes && props.nodes.length > 0 && isDomChartReady) {
      let data = [...props.nodes]
      let roots = findRoot(data)
      chart = new OrgChart(divRef.current, {
        template: "customTemplate",
        nodes: data,
        showYScroll: OrgChart.scroll.visible,
        showXScroll: OrgChart.scroll.visible,
        mouseScrool: OrgChart.action.none,
        scaleInitial: OrgChart.match.width,
        scaleMax: 99999999999999,
        scaleMin: -99999999999999,
        enableSearch: false,
        collapse: { level: 1, allChildren: true },
        roots: roots,
        editUI: new editForm(),
        nodeBinding: {
          field_0: "code",
          field_1: "nameEn",
          field_2: "nameTh",
          img_0: "img",
        },
        tags: {
          "level0": {
            subLevels: 0,
          },
          "level1": {
            subLevels: 1,
          },
          "level2": {
            subLevels: 2,
          },
          "level3": {
            subLevels: 3,
          },
          "level4": {
            subLevels: 4,
          },
          "level5": {
            subLevels: 5,
          },
          "level6": {
            subLevels: 6,
          },
          "level7": {
            subLevels: 7,
          },
          "level8": {
            subLevels: 8,
          },
        },
      })
      // chart.changeRoots(roots)
      let tags = []
      let resultNodes = data.map(item => {
        let findNode = props.searchNodes.find(sItem => item.id === sItem.id)
        if (findNode) {
          return {
            ...item,
            tags: [...item.tags, "search"]
          }
        } else {
          tags = [...item.tags].filter(v => v !== 'search')
          return {
            ...item,
            tags: [tags]
          }
        }
      })
      chart.load(resultNodes)
      let expandNodes = [...props.searchNodes].map(item => {
        return item.id
      })
      if (expandNodes.length > 0) { chart.expand(null, expandNodes) }
    }
  }, [props.nodes, props.searchNodes, isDomChartReady])

  return (
    <React.Fragment>
      <div id="tree" ref={divRefCallback} style={{ height: 'calc(100vh - 180px)', width: '100%' }} ></div>
      <div style={{
        position: 'absolute',
        right: '35px',
        bottom: '10px',
        display: 'flex',
      }}>
        <div id="tree-zoom-minus" style={{ borderRadius: '4px 0px 0px 4px' }} class="zoomBtn" onClick={() => doZoom("out")}><MinusIcon></MinusIcon></div>
        <Select
          id="metric-select"
          variant="outlined"
          defaultValue=""
          displayEmpty
          size="small"
          fullWidth
          className="white-bg"
          sx={{ width: '100px', borderRadius: "0!important", borderLeft: 0, borderRight: 0 }}
          value={currentZoomSelected}
        >
          <MenuItem value={25} onClick={() => setZoomLevel(25)}>
            <Typography variant="sub_label" style={{ fontWeight: "400" }}>25%</Typography>
          </MenuItem>
          <MenuItem value={50} onClick={() => setZoomLevel(50)}>
            <Typography variant="sub_label" style={{ fontWeight: "400" }}>50%</Typography>
          </MenuItem>
          <MenuItem value={75} onClick={() => setZoomLevel(75)}>
            <Typography variant="sub_label" style={{ fontWeight: "400" }}>75%</Typography>
          </MenuItem>
          <MenuItem value={100} onClick={() => setZoomLevel(100)}>
            <Typography variant="sub_label" style={{ fontWeight: "400" }}>100%</Typography>
          </MenuItem>
          <MenuItem value={150} onClick={() => setZoomLevel(150)}>
            <Typography variant="sub_label" style={{ fontWeight: "400" }}>150%</Typography>
          </MenuItem>
          <MenuItem value={200} onClick={() => setZoomLevel(200)}>
            <Typography variant="sub_label" style={{ fontWeight: "400" }}>200%</Typography>
          </MenuItem>
          <MenuItem value={300} onClick={() => setZoomLevel(300)}>
            <Typography variant="sub_label" style={{ fontWeight: "400" }}>300%</Typography>
          </MenuItem>
        </Select>
        <div id="tree-zoom-plus" style={{ borderRadius: '0px 4px 4px 0px' }} class="zoomBtn" onClick={() => doZoom("in")}><PlusIcon></PlusIcon></div>
      </div>
    </React.Fragment>
  )
}

export default OrganizationChart;
